import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LanguageService } from '../_services/index';

@Pipe({
    name: 'txtTranslate',
    pure: false,
    standalone: false
})
export class TxtMapTranslatePipe implements PipeTransform {

  constructor(private translateService: TranslateService,
    public languageService: LanguageService) {
  }

  transform(map: any): any {
    /*console.log('Translate data:'+JSON.stringify(map));*/
    //console.log('current lang:'+this.translateService.currentLang+', default:'+this.translateService.fallbackLang);
    return this.getStr(map);
  }

  getStr(strMap){
    if(strMap){
      if(strMap[this.languageService.currentLang])
        return strMap[this.languageService.currentLang];
      /*if(strMap[this.translateService.fallbackLang])
        return strMap[this.translateService.fallbackLang];*/
      for(var key of Object.keys(strMap)){
        if(strMap[key] && strMap[key].length>0){
          return '('+key+') '+strMap[key];
        }
      }
    }
    if(typeof strMap === 'object'){
      return null;
    }
    return strMap;
  }

}
